// extracted by mini-css-extract-plugin
module.exports = {"SalaryRange_dark":"style_SalaryRange_dark__3-J94","SalaryRange_light":"style_SalaryRange_light__39Gja"};